import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      marginBottom: 12,
    },
    'root--no-height': {
      height: 'auto',
    },
    content: {
      display: 'flex',
      height: '100%',
      fontSize: 13,
      color: color.$13,
      backgroundColor: color.$8,
      borderRadius: 12,
      '& > video': {
        width: '100%',
        borderRadius: 12,
      },
    },
    'content--default': {
      width: '100%',
      height: 186,
    },
  }),
  {
    name: 'RichVideoPreview',
  },
);

function RichVideoPreview({ message }) {
  const classes = useStyles();
  const element = (message?.data?.elements || [])[0];
  const { videoUrl } = element || {};

  return (
    <div
      className={classnames(classes.root, {
        [classes['root--no-height']]: !!videoUrl,
      })}
    >
      <div
        className={classnames(classes.content, {
          [classes['content--default']]: !videoUrl,
        })}
      >
        {videoUrl && (
          <video src={videoUrl} controls>
            <track kind="captions" />
          </video>
        )}
      </div>
    </div>
  );
}

export default RichVideoPreview;
